import React, { useState } from 'react';

export default function InteractiveQuiz({ question, choices, correctAnswer }) {
  const [selected, setSelected] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);

  const handleAnswer = (choice) => {
    setSelected(choice);
    setIsCorrect(choice === correctAnswer);
  };

  return (
    <div className="mt-4">
      <p className="font-semibold text-gray-800">{question}</p>
      <ul className="list-disc list-inside mt-1">
        {choices.map((choice, idx) => (
          <li key={idx}>
            <button
              onClick={() => handleAnswer(choice)}
              className={`mt-1 px-3 py-1 rounded text-left w-full 
                ${selected === choice
                  ? isCorrect
                    ? 'bg-green-100 border border-green-500 text-green-700'
                    : 'bg-red-100 border border-red-500 text-red-700'
                  : 'bg-white hover:bg-gray-100 border'}`}
            >
              {choice}
            </button>
          </li>
        ))}
      </ul>

      {selected && (
        <p className={`mt-2 font-medium ${isCorrect ? 'text-green-600' : 'text-red-600'}`}>
          {isCorrect ? 'Correct!' : `Incorrect. The correct answer is: ${correctAnswer}`}
        </p>
      )}
    </div>
  );
}
